import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.className)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lines, (n) => {
      return (_openBlock(), _createElementBlock("div", {
        key: n,
        class: _normalizeClass(`${_ctx.className}__line`)
      }, null, 2))
    }), 128))
  ], 2))
}